import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { getFirstAvailableDocumentSectionRoute } from '@/configs/organizationSectionsRouting';
import { ROUTES } from '@/configs/routes';
import { useOrganizationSectionsStore } from '@/stores/local/shared/OrganizationSectionsStore';

const DocumentDefaultRedirect: React.FC = () => {
  const { id, documentId } = useParams();
  const sectionsStore = useOrganizationSectionsStore();

  if (!id || !documentId) {
    return <Navigate to={ROUTES.root.path} replace />;
  }

  const fallbackRoute = getFirstAvailableDocumentSectionRoute({
    enabledSections: sectionsStore.enabledDocumentSections,
    organizationId: id,
    documentId: String(documentId),
  });

  if (!fallbackRoute) {
    return <Navigate to={ROUTES.organization.documents.create(id)} replace />;
  }

  return <Navigate to={fallbackRoute} replace />;
};

export default observer(DocumentDefaultRedirect);
